import { WindowRef } from '@shared/modules/window-ref/window-ref';
import { IFileMetaData } from '@store/reducers/document-upload/document-upload.reducer';

export async function areBlobUrlsValid(
  filesMetaData: IFileMetaData[],
  windowRef: WindowRef,
): Promise<boolean> {
  const objectURL = filesMetaData[0]?.objectURL;

  // A hydrated file carries objectURL: ''. fetch('') resolves as a relative URL against
  // the current document and returns ok:true, so without this guard the caller would take
  // the "blobs are valid" branch and rebuild the file from the HTML page.
  if (!objectURL) {
    return false;
  }

  try {
    const response = await windowRef.nativeWindow.fetch(objectURL);
    return response.ok;
  } catch {
    return false;
  }
}
